import { Directive } from '@angular/core';
import * as i0 from "@angular/core";
export class PlaceholderLoadingDirective {
    templateRef;
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PlaceholderLoadingDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: PlaceholderLoadingDirective, selector: "[scPlaceholderLoading]", ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PlaceholderLoadingDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[scPlaceholderLoading]',
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });
